import { Card, Typography, Space } from 'antd'

import Styled from './styled'

export default function MyCard ({ children, title, titleExtra, extra, loading = false }) {
  return (
    <Styled className='card-component'>
      <Card
        loading={loading}
        title={
          title || titleExtra ? (
            <Space size='large'>
              <Typography.Title level={5}>{title}</Typography.Title>
              <div className='title-extra'>{titleExtra}</div>
            </Space>
          ) : null
        }
        extra={extra}
      >
        {children}
      </Card>
    </Styled>
  )
}
